const doc = [({"reverse_charge":"Hizmet alıcısı geri ödeme mekanizmasına göre KDV'den sorumludur. "})];
module.exports = doc.length <= 1 ? doc[0] : doc;